import { render, staticRenderFns } from "./AssinaturaPCAModal.vue?vue&type=template&id=a868e832"
import script from "./AssinaturaPCAModal.vue?vue&type=script&lang=js"
export * from "./AssinaturaPCAModal.vue?vue&type=script&lang=js"
import style0 from "./AssinaturaPCAModal.vue?vue&type=style&index=0&id=a868e832&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports